import { SHOULDER_HEIGHT_OPTIONS } from '@flows/configs/petHealthV2/constants'
import {
  NATIVE_TITLE_SIZE,
  v2InfoNoteHeading,
  v2InfoNoteText,
  v2Text,
  v2TextWithPetName,
} from '@flows/configs/petHealthV2/steps/elements/shared'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { ElementFragment } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'
import { BaseSchema_PetHealthV2GetsafeDe } from '@flows/insurance/schemas'

const PLATFORM_LOOK = {
  native: {
    title: { size: NATIVE_TITLE_SIZE },
    choice: { variant: 'filled' },
    infoBox: { noPadding: true },
    infoContent: [
      v2InfoNoteHeading('steps.shoulder_height.info.title'),
      v2InfoNoteText('steps.shoulder_height.info.text'),
    ],
  },
  web: {
    title: {},
    choice: {},
    infoBox: {},
    infoContent: [
      { type: 'title', isSmall: true, text: v2Text('steps.shoulder_height.info.title') },
      { type: 'text', text: v2Text('steps.shoulder_height.info.text') },
    ],
  },
} as const

export const shoulderHeightElements = (params: StepConfigParams, platform: 'native' | 'web') => {
  const look = PLATFORM_LOOK[platform]
  return {
    elements: [
      {
        type: 'title',
        text: v2TextWithPetName(params, 'steps.shoulder_height.title'),
        ...look.title,
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        ...look.choice,
        name: params.helperFunctions.getParamPath('shoulder_height_class'),
        options: SHOULDER_HEIGHT_OPTIONS.map((value) => ({
          value,
          label: v2Text(`steps.shoulder_height.options.${value}`),
        })),
      },
      {
        type: 'infoBox',
        showInfoIcon: true,
        ...look.infoBox,
        contentConfiguration: look.infoContent,
      },
    ],
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('shoulder_height_class')]:
        BaseSchema_PetHealthV2GetsafeDe.shape.shoulder_height_class.unwrap(),
    }),
  } as const satisfies ElementFragment
}
